var render = function render(){var _vm=this,_c=_vm._self._c;return _c('maintenance-page',{attrs:{"page-title":"Customer","page-icon":"mdi-account-multiple","collection-name":"customer","done-redirect-url":"/auth/admin/customer?isHistory=true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }